import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { EventsWebService } from './events.web.service';
import { EventListDto, EventDto } from 'UvExplorerServer.Dtos.TS/Events';
import { MessageService } from 'base';


@Injectable()
export class EventsService {

	constructor(private eventsWebService: EventsWebService,
		private messageService: MessageService) {

		return;
	}

	public getEvents(scopeGuid: string, agentGuid: string, clientAgentGuid: string,
		schedDiscGuid: string, schedDiscResultGuid: string,
		category: string, source: string, level: string, description: string,
		sortBy: string, ascending: boolean, skip: number, limit: number,
		showBusy: boolean): Observable<EventListDto> {

		let subject = new Subject<EventListDto>();


		if (showBusy) {
			this.messageService.startWork();
		}
		this.eventsWebService.getEvents(scopeGuid, agentGuid, clientAgentGuid, schedDiscGuid,
			schedDiscResultGuid, category, source, level, description, sortBy, ascending, skip, limit).subscribe(
				(result: EventListDto) => {
					if (showBusy) {
						this.messageService.endWork();
					}
					subject.next(result);
				},
				(error) => {
					if (showBusy) {
						this.messageService.endWork();
					}
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

}